import { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HistoryModal from './components/HistoryModal';
import Home from './pages/Home';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Upgrade from './pages/Upgrade';
import Pricing from './pages/Pricing';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import './index.css';

function HomeOrLanding() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Home /> : <Landing />;
}

export default function App() {
  const [showHistory, setShowHistory] = useState(false);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Header onHistoryClick={() => setShowHistory(true)} />
        <Routes>
          <Route path="/"         element={<HomeOrLanding />} />
          <Route path="/login"    element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/upgrade"  element={<Upgrade />} />
          <Route path="/pricing"  element={<Pricing />} />
          <Route path="/terms"    element={<Terms />} />
          <Route path="/privacy"  element={<Privacy />} />
          <Route path="/refund"   element={<Refund />} />
        </Routes>
        <Footer />
        {showHistory && <HistoryModal onClose={() => setShowHistory(false)} />}
      </BrowserRouter>
    </AuthProvider>
  );
}
